<span class="d-flex flex-column name-column">
  <span class="d-flex flex-row align-content-center">
    <a
      class="td-link pr-2"
      *ngIf="location.enabled"
      [innerText]="location.name"
      (click)="navigateToLocationPage(location._id, '/waitlist')"
    ></a>
    <span *ngIf="!location.enabled" class=" td-link td-link-disabled pr-2" [innerText]="location.name"></span>
    <success-badge-light *ngIf="location._id === currentLocationId" [label]="'CURRENT'"></success-badge-light>
    <light-badge *ngIf="!location.enabled" [label]="'DISABLED'"></light-badge>
  </span>
  <p [innerText]="email" class="mb-0"></p>
  <p [innerText]="getAddressString(location.address)" class="mb-0"></p>
  <p [innerText]="location.phoneNumber | trTel: location.country" class="pt-0"></p>
</span>
